// src/components/cuenta/ProfileMenu.js
import React from 'react';
import './ProfileMenu.css';

// Componente `LogoutIcon` que renderiza esta parte de la interfaz.
const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </svg>
);

// Componente `AccionesIcon` que renderiza esta parte de la interfaz.
const AccionesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
  </svg>
);

// Componente `AsambleasIcon` que renderiza esta parte de la interfaz.
const AsambleasIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

// Componente `PoderesIcon` que renderiza esta parte de la interfaz.
const PoderesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <path d="M12 18v-6"></path>
    <path d="M9 15l3 3 3-3"></path>
  </svg>
);

// Componente `ReceiptIcon` que renderiza esta parte de la interfaz.
const ReceiptIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ position: 'relative', top: '-1px' }}>
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"></path>
    <line x1="16" y1="8" x2="8" y2="8"></line>
    <line x1="16" y1="12" x2="8" y2="12"></line>
    <line x1="10" y1="16" x2="8" y2="16"></line>
  </svg>
);

// Componente `InboxIcon` que renderiza esta parte de la interfaz.
const InboxIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline>
    <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
  </svg>
);

const ROLE_DETAILS = {
  user: { title: 'Cliente', description: 'Mis solicitudes y documentos', mark: 'CL' },
  admin: { title: 'Administrador Wisby', description: 'Gestión y asignación de folios', mark: 'AD' },
  abogado_wisby: { title: 'Abogado Wisby', description: 'Revisión de Actas y firmas', mark: 'AW' },
  notario: { title: 'Notario titular', description: 'Escrituras y equipo notarial', mark: 'NT' },
  admin_notaria: { title: 'Administrador de notaría', description: 'Operación y expedientes notariales', mark: 'AN' },
  abogado_notaria: { title: 'Abogado de notaría', description: 'Mis escrituras asignadas', mark: 'EN' },
};
// La vista anterior se conserva para sesiones existentes, pero ya no se ofrece
// Administrador de notaría como espacio elegible.
const ROLE_ORDER = ['admin', 'abogado_wisby', 'notario', 'abogado_notaria', 'user'];

// Componente `ProfileMenu` que renderiza esta parte de la interfaz.
export default function ProfileMenu({ userName, onNavigate, onLogout, userRole = 'user', isAdmin = false,
  availableRoles = [], rolesLoading = false, rolesError = '', roleSwitchBusy = false, roleSwitchError = '',
  onRoleSwitch, onRetryRoles, t = {} }) {
  const staffRole = ['admin', 'abogado_wisby', 'notario', 'admin_notaria', 'abogado_notaria'].includes(userRole);
  const notaryLawyer = userRole === 'abogado_notaria';
  const wisbyLawyer = userRole === 'abogado_wisby';
  const orderedRoles = ROLE_ORDER.filter(role => availableRoles.includes(role));
  const showRoleSelector = rolesLoading || Boolean(rolesError) || orderedRoles.length > 1;
  const selectedDescription = ROLE_DETAILS[userRole]?.title || 'Mi cuenta';
  
  // Función `handleAdminClick` que gestiona la interacción o el evento correspondiente.
  const handleAdminClick = () => {
    onNavigate('admin');
  };

  // Función `handleProfileNavigate` que gestiona la interacción o el evento correspondiente.
  const handleProfileNavigate = (section, tab) => {
    onNavigate(section, tab);
    window.dispatchEvent(new CustomEvent('forceProfileTabChange', { detail: tab }));
  };

  return (
    <div className={`profile-dropdown-menu ${staffRole ? 'profile-dropdown-staff' : 'profile-dropdown-crystal'}${showRoleSelector ? ' has-role-switcher' : ''}`}>
      {/* Encabezado con saludo. */}
      <div className="menu-header">
        <div className="profile-user-block"><span className="user-greeting">Hola, {userName}</span>
          <span className="profile-current-role">{selectedDescription}</span></div>
        {isAdmin && <span className="admin-badge">Admin</span>}
        {userRole === 'notario' && <span className="admin-badge notario-badge">Notario</span>}
        {userRole === 'abogado_notaria' && <span className="admin-badge notario-badge">Abogado de Notaría</span>}
        {userRole === 'abogado_wisby' && <span className="admin-badge lawyer-badge">Abogado - Wisby</span>}
      </div>
      
      <ul className="menu-list">

        {showRoleSelector && <li className="role-switcher-block">
          <div className="role-switcher-heading">
            <span>CAMBIAR DE ESPACIO DE TRABAJO</span>
            {orderedRoles.length > 1 && <small>{orderedRoles.length} roles disponibles</small>}
          </div>
          {rolesLoading ? <p className="role-switcher-feedback" role="status">Consultando tus roles…</p>
            : rolesError ? <div className="role-switcher-feedback" role="alert">
                <p>{rolesError}</p>
                <button type="button" onClick={onRetryRoles}>Reintentar</button>
              </div>
            : <div className="role-switcher-options" role="group" aria-label="Espacios de trabajo">
                {orderedRoles.map(role => {
                  const info = ROLE_DETAILS[role];
                  const active = role === userRole;
                  return <button key={role} type="button"
                    className={`role-switcher-item${active ? ' is-active' : ''}`}
                    aria-label={active ? `Rol activo: ${info.title}` : `Cambiar a ${info.title}`}
                    aria-pressed={active}
                    disabled={roleSwitchBusy}
                    onClick={() => onRoleSwitch?.(role)}>
                    <span className="role-switcher-icon" aria-hidden="true">{info.mark}</span>
                    <span className="role-switcher-copy"><strong>{info.title}</strong><small>{info.description}</small></span>
                    <span className="role-switcher-status" aria-hidden="true">{active ? '✓' : '›'}</span>
                  </button>;
                })}
              </div>}
          {roleSwitchBusy && <p className="role-switcher-feedback" role="status">Abriendo espacio de trabajo…</p>}
          {roleSwitchError && <p className="role-switcher-error" role="alert">{roleSwitchError}</p>}
        </li>}

        {staffRole ? (
          <>
            <li className="menu-group-label">{isAdmin ? 'Gestión de folios' : 'Mis expedientes'}</li>
            <li>
              <button
                className="staff-folio-option"
                disabled={roleSwitchBusy}
                onClick={isAdmin
                  ? handleAdminClick
                  : wisbyLawyer
                    ? () => onNavigate('folios-abogado')
                    : () => onNavigate('notario-dashboard')}
              >
                <span className="menu-item-content">
                  <InboxIcon />
                  <span>{isAdmin ? 'Panel de folios' : notaryLawyer || wisbyLawyer ? 'Mis folios asignados' : 'Dashboard de notaría'}</span>
                </span>
              </button>
            </li>
          </>
        ) : (
          <>
            <li className="menu-group-label">Documentos legales</li>
            <li>
              <button onClick={() => handleProfileNavigate('profile', 'boletas')}>
                <span className="menu-item-content"><AccionesIcon /><span>{t.menuAcciones || 'Mis Acciones'}</span></span>
              </button>
            </li>
            <li>
              <button onClick={() => handleProfileNavigate('profile', 'asambleas')}>
                <span className="menu-item-content"><AsambleasIcon /><span>{t.menuAsambleas || 'Mis Asambleas'}</span></span>
              </button>
            </li>
            <li>
              <button onClick={() => handleProfileNavigate('profile', 'poderes')}>
                <span className="menu-item-content"><PoderesIcon /><span>{t.menuPoderes || 'Mis Poderes'}</span></span>
              </button>
            </li>
            <li className="separator"></li>
            <li className="menu-group-label">Gestión de cuenta</li>
            <li>
              <button onClick={() => onNavigate('facturacion')}>
                <span className="menu-item-content"><ReceiptIcon /><span>{t.menuFacturacion || 'Facturación'}</span></span>
              </button>
            </li>
          </>
        )}

        <li className="separator"></li>

        {/* CERRAR SESIÓN */}
        <li>
          <button onClick={onLogout} className="logout-option">
            <span>{t.cerrarSesion || 'Cerrar Sesión'}</span>
            <LogoutIcon />
          </button>
        </li>
      </ul>
    </div>
  );
}
